import { createContext, useContext, useEffect, useState } from 'react';
import {
  getFingertipsLinks,
  getHealthSnapshot,
  getHealthSnapshotCoveredMembersHw,
  getSavingsSnapshot,
  getOtherCompanyBenefits,
} from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type HwDbDcMidYearDashboardState = {
  healthSnapshot: Array<any>;
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  savingsSnapshot: Array<any>;
  coveredFamilyMembers: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const HwDbDcMidYearDashboardStore =
  createContext<HwDbDcMidYearDashboardState>({
    healthSnapshot: [],
    fingertipLinks: [],
    companiesMessages: [],
    savingsSnapshot: [],
    coveredFamilyMembers: [],
    otherCompanyBenefits: [],
  });

const { Provider } = HwDbDcMidYearDashboardStore;

export const HwDbDcMidYearDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [HwDbDcMidYearDashboardState, setHwDbDcMidYearDashboardState] =
    useState<HwDbDcMidYearDashboardState>({
      healthSnapshot: [],
      fingertipLinks: [],
      companiesMessages: [],
      savingsSnapshot: [],
      coveredFamilyMembers: [],
      otherCompanyBenefits: [],
    });

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies(selectedPersona);
    let savingsSnapshot = getSavingsSnapshot();
    let coveredFamilyMembers = getHealthSnapshotCoveredMembersHw();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setHwDbDcMidYearDashboardState({
      healthSnapshot,
      fingertipLinks,
      companiesMessages,
      savingsSnapshot,
      coveredFamilyMembers,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={HwDbDcMidYearDashboardState}>{children}</Provider>;
};
